<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Aguarde :show="httpSend"></Aguarde>

    <div class="empresas-wrap">

      <!-- Filtros de Pesquisa -->
      <div class="table-card mb-section">
        <div class="table-header">
          <div class="header-left-group">
            <p class="chart-title">Filtros de Pesquisa</p>
          </div>
        </div>
        <div class="filtros-body">
          <b-form @submit.prevent="pesquisar()">
            <div class="filtros-grid">
              <div class="campo">
                <label for="eco_codigo">Código</label>
                <input id="eco_codigo" v-model="filtro.eco_codigo" type="text" class="campo-input"
                       placeholder="Ex: 4184">
              </div>
              <div class="campo">
                <label for="pes_nome">Razão Social / Nome</label>
                <input id="pes_nome" v-model="filtro.pes_nome" type="text" class="campo-input"
                       placeholder="Razão social ou nome">
              </div>
              <div class="campo">
                <label for="eco_nome_fantasia">Nome Fantasia</label>
                <input id="eco_nome_fantasia" v-model="filtro.eco_nome_fantasia" type="text" class="campo-input"
                       placeholder="Nome fantasia">
              </div>
              <div class="campo">
                <label for="pes_cpfcnpj">CNPJ/CPF</label>
                <the-mask id="pes_cpfcnpj" class="campo-input" v-model="filtro.pes_cpfcnpj"
                          :mask="['###.###.###-##', '##.###.###/####-##']" placeholder="Documento"/>
              </div>
            </div>
            <div class="filtros-acoes">
              <button type="submit" class="btn-pesquisar">
                <i class="bx bx-search"></i> Pesquisar
              </button>
              <button type="button" @click="limparFiltros()" class="btn-limpar">
                <i class="bx bx-eraser"></i> Limpar
              </button>
            </div>
          </b-form>
        </div>
      </div>

      <!-- Lista de Empresas -->
      <div class="table-card">
        <div class="table-header">
          <div class="header-left-group">
            <p class="chart-title">Empresas</p>
            <span class="badge-count">{{
                empresas.length
              }} {{ empresas.length === 1 ? 'registro' : 'registros' }}</span>
          </div>
        </div>

        <div class="table-wrapper">
          <table v-if="empresas.length > 0" class="nf-table">
            <thead>
            <tr>
              <th>Código</th>
              <th>Razão Social / Nome</th>
              <th>CNPJ/CPF</th>
              <th>Tributação</th>
              <th>Status</th>
              <th class="text-center th-right">Ação</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="s in empresas" :key="s.eco_codigo" :class="{ 'row--selecionada': s.eco_codigo === selecionada }">
              <td class="td-numero">{{ s.eco_codigo }}</td>
              <td>
                <div class="cell-stack">
                  <span class="cell-primary">{{ s.pes_nome }}</span>
                  <span class="cell-sub">{{ s.eco_nome_fantasia || 'Sem nome fantasia' }}</span>
                </div>
              </td>
              <td class="td-mono">
                <span v-if="s.pes_cpfcnpj && s.pes_cpfcnpj.length < 12"
                      class="cell-primary">{{ s.pes_cpfcnpj | VMask('###.###.###-##') }}</span>
                <span v-else class="cell-primary">{{ s.pes_cpfcnpj | VMask('##.###.###/####-##') }}</span>
              </td>
              <td>
                <div class="cell-stack">
                  <span class="cell-primary">{{ s.eco_tributacao | tributacaoPessoa }}</span>
                  <span class="cell-sub">{{ s.tab_103nome || '—' }}</span>
                </div>
              </td>
              <td>
                <span class="status-badge" :class="statusEmpresa(s.tab_107situacao).cls">
                  {{ statusEmpresa(s.tab_107situacao).label }}
                </span>
              </td>
              <td class="td-action">
                <button type="button" class="btn-selecionar"
                        :class="{ 'btn-selecionar--ativo': s.eco_codigo === selecionada }"
                        @click.stop="selecionar(s)">
                  <i class="mdi mdi-check"></i>
                  {{ s.eco_codigo === selecionada ? 'Selecionada' : 'Selecionar' }}
                </button>
              </td>
            </tr>
            </tbody>
          </table>

          <!-- Estado vazio -->
          <div v-else class="empty-state">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
              <circle cx="18" cy="18" r="17" stroke="#e2e8f0" stroke-width="1.5"/>
              <path d="M12 18h12M18 12v12" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <p>Nenhuma empresa encontrada ou usuário sem acesso</p>
          </div>
        </div>

      </div>

    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import Aguarde from "@/components/widgets/aguarde.vue";
import {TheMask} from 'vue-the-mask';
import {authMethods} from "@/state/helpers";
import appConfig from "@/dados/app.config.json";
import {getEmpresas} from "@/api/core/pessoa";

export default {
  page: {
    title: "Empresas",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Aguarde,
    TheMask
  },
  data() {
    return {
      title: "Empresas",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Empresas',
          active: true,
        },
      ],
      httpSend: false,
      filtro: {
        eco_codigo: "",
        pes_nome: "",
        eco_nome_fantasia: "",
        pes_cpfcnpj: "",
      },
      empresas: [],
      por_pagina: 10,
      pagina: 1,
      selecionada: null,
    };
  },
  computed: {
    totalPaginas() {
      return this.empresas.length;
    },
    empresasPagina() {
      const inicio = (this.pagina - 1) * this.por_pagina;
      return this.empresas.slice(inicio, inicio + this.por_pagina);
    },
  },
  created() {
    this.selecionada = this.$store.state.auth.currenEmpresa ? this.$store.state.auth.currenEmpresa.eco_codigo : null;
    this.pesquisar();
  },
  methods: {
    ...authMethods,
    pesquisar() {
      this.httpSend = true;
      getEmpresas(this.filtro).then(result => {
        if (result.status) {
          this.empresas = result.dados;
        }
      }).catch(console.error).finally(() => {
        this.httpSend = false;
      });
    },
    limparFiltros() {
      this.filtro.eco_codigo = "";
      this.filtro.pes_nome = "";
      this.filtro.eco_nome_fantasia = "";
      this.filtro.pes_cpfcnpj = "";
      this.pagina = 1;
    },
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.pagina = parseInt(pageNum);
    },
    statusEmpresa(codigo) {
      switch (String(codigo)) {
        case '1003':
          return {label: 'Ativa', cls: 'status-badge--autorizada'};
        case '1004':
          return {label: 'Suspensa', cls: 'status-badge--pendente'};
        case '1006':
          return {label: 'Ativa Não Regular', cls: 'status-badge--devolucao'};
        case '1002':
          return {label: 'Nula', cls: 'status-badge--cancelada'};
        case '1005':
          return {label: 'Inapta', cls: 'status-badge--cancelada'};
        case '1007':
          return {label: 'Baixada', cls: 'status-badge--cancelada'};
        default:
          return {label: '—', cls: 'status-badge--neutra'};
      }
    },
    selecionar(empresa) {
      if (!empresa) {
        return;
      }
      this.selecionada = empresa.eco_codigo;
      this.httpSend = true;
      this.empresaAtual({...empresa, redirectFrom: 'painel'})
          .catch(() => {})
          .finally(() => {
            this.httpSend = false;
          });
    },
  },
};
</script>

<style scoped>
.empresas-wrap {
  width: 100%;
}

/* ─── Cards ──────────────────────────────────────────────── */
.table-card {
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.mb-section {
  margin-bottom: 1.25rem;
}

.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.1rem 1.5rem;
  border-bottom: 0.5px solid #f1f5f9;
  flex-wrap: wrap;
  gap: 8px;
}

.header-left-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chart-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.badge-count {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  background: #f1f5f9;
  border-radius: 999px;
  padding: 2px 9px;
}

/* ─── Filtros ────────────────────────────────────────────── */
.filtros-body {
  padding: 1.25rem 1.5rem;
}

.filtros-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.campo {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.campo label {
  margin: 0;
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.campo-input {
  width: 100%;
  border: 0.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  color: #334155;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.campo-input::placeholder {
  color: #cbd5e1;
}

.campo-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.filtros-acoes {
  display: flex;
  gap: 10px;
  margin-top: 1.25rem;
}

.btn-pesquisar {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #4f6ef7;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
}

.btn-pesquisar:hover {
  background: #3b55e0;
}

.btn-pesquisar:active {
  transform: scale(0.98);
}

.btn-limpar {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #64748b;
  border: 0.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.btn-limpar:hover {
  background: #f8fafc;
  color: #334155;
}

/* ─── Tabela ─────────────────────────────────────────────── */
.table-wrapper {
  overflow-x: auto;
}

.nf-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.nf-table thead tr {
  background: #f8fafc;
}

.nf-table th {
  padding: 9px 1.5rem;
  text-align: left;
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
}

.th-right {
  text-align: right;
}

.nf-table td {
  padding: 8px 1rem;
  border-top: 0.5px solid #f1f5f9;
  color: #334155;
  vertical-align: middle;
}

.nf-table tbody tr {
  transition: background 0.12s;
}

.nf-table tr:hover td {
  background: #f8fafc;
}

.row--selecionada td {
  background: #eef2ff !important;
}

.row--selecionada:hover td {
  background: #e6ebff !important;
}

.td-numero {
  font-weight: 600;
  color: #0f172a;
}

.cell-stack {
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.35;
}

.cell-primary {
  font-weight: 500;
  color: #0f172a;
}

.cell-sub {
  font-size: 11px;
  color: #94a3b8;
}

.td-mono {
  font-size: 12px;
  color: #475569;
  width: 15%;
}

.td-muted {
  color: #94a3b8;
}

.td-action {
  text-align: right;
  white-space: nowrap;
}

/* ─── Status badges ──────────────────────────────────────── */
.status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.status-badge--autorizada {
  background: #f0fdf4;
  color: #16a34a;
}

.status-badge--cancelada {
  background: #fef2f2;
  color: #dc2626;
}

.status-badge--pendente {
  background: #fffbeb;
  color: #d97706;
}

.status-badge--devolucao {
  background: #fff7ed;
  color: #ea580c;
}

.status-badge--neutra {
  background: #f1f5f9;
  color: #94a3b8;
}

/* ─── Botão selecionar ───────────────────────────────────── */
.btn-selecionar {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #fff;
  color: #4f6ef7;
  border: 0.5px solid #c7d2fe;
  border-radius: 7px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, transform 0.1s;
  white-space: nowrap;
}

.btn-selecionar:hover {
  background: #4f6ef7;
  color: #fff;
}

.btn-selecionar:active {
  transform: scale(0.97);
}

.btn-selecionar--ativo {
  background: #16a34a;
  color: #fff;
  border-color: #16a34a;
}

.btn-selecionar--ativo:hover {
  background: #15803d;
  color: #fff;
}

/* ─── Estado vazio ───────────────────────────────────────── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 3rem;
  color: #94a3b8;
  font-size: 13px;
}

/* ─── Paginação ──────────────────────────────────────────── */
.paginacao-wrap {
  padding: 1rem 1.5rem;
  border-top: 0.5px solid #f1f5f9;
}

/* ─── Responsivo ─────────────────────────────────────────── */
@media (max-width: 991px) {
  .filtros-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 575px) {
  .filtros-grid {
    grid-template-columns: 1fr;
  }

  .filtros-acoes {
    flex-direction: column;
  }

  .btn-pesquisar,
  .btn-limpar {
    justify-content: center;
  }
}
</style>
